module.exports = __webpack_public_path__ + "static/Unicorn-c24a3dcb100aa1fac5eb44a3bebcad29.jpg";